// eslint:disable:max-func-body-length
import React from 'react';
import { CaseLogChanges } from './types';
import styles from './change-log-link.scss';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { isValidDateString } from 'app/infrastructure/validation/date';
export const changeLogContents = (
  changes: CaseLogChanges[], 
  formatters: any, 
  textMessageNoChangesExist: string
  ) => {  

  const dateFormatter = (date: string): string => {
    return formatters?.formatDate(parseAsDateUTC(date), {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZone: 'UTC'
    });
  };

  const formattedValue = (value: string): string => {
    if(isValidDateString(value)) {
      return dateFormatter(value);
    }
    return value;
  };

  const renderChanges = (changeItem: CaseLogChanges, index: number) => {
    if(!changeItem?.fieldDescription) {
      return null;
    }

    const renderHeaderDescription = (description: string, indexPosition: number): React.ReactNode => {
      return description && changeItem?.entityPath[indexPosition].entityType === changeItem?.entityPath[indexPosition].description ?
        <span className={`${styles.withHash} ${entityAddedOrRemovedStyle}`}>
          {' #' + changeItem?.entityPath[indexPosition]?.entityId}</span> :
        <span className={`${styles.sectionHeaderDescription} ${entityAddedOrRemovedStyle}`}>{description}</span>;
    };

    const renderSubHeader = (indexPosition: number) => {
      return <>
        <div className={`${styles.subSectionHeader}`}>
          <span className={styles.subSectionHeaderTitle}>{changeItem.entityPath[indexPosition]?.entityType}</span>
          {changeItem.entityPath[indexPosition]?.description && <span className={`${styles.subSectionHeaderDescription}`}>
            {renderHeaderDescription(changeItem.entityPath[indexPosition]?.description, indexPosition)}
          </span>}
        </div>
      </>;
    };

    const currentEntityPathLength = changeItem?.entityPath?.length;
    const previousEntityPathLength = changes?.[index-1]?.entityPath.length;
    const anIterator = currentEntityPathLength > 1;

    const hasSameEntityPathTransLevel = 
      JSON.stringify(changeItem.entityPath.slice(0, 1)) === JSON.stringify(changes?.[index-1]?.entityPath.slice(0, 1));
    const hasSameEntityPathIteratorLevel = 
      JSON.stringify(changeItem.entityPath.slice(0, 2)) === JSON.stringify(changes?.[index-1]?.entityPath.slice(0, 2));
    const hasSameEntityPathCategoryLevel = 
      JSON.stringify(changeItem.entityPath.slice(0, 3)) === JSON.stringify(changes?.[index-1]?.entityPath.slice(0, 3));
    const hasSameEntityPathSubCategoryLevel = 
      JSON.stringify(changeItem.entityPath.slice(0, 4)) === JSON.stringify(changes?.[index-1]?.entityPath.slice(0, 4));

    const isDifferentSubSectionFromPrevious = currentEntityPathLength === 4 && 
      JSON.stringify(changeItem.entityPath.slice(0, 3)) !== JSON.stringify(changes?.[index-1]?.entityPath.slice(0, 3));
    
    const shouldDisplaySubSubSection = currentEntityPathLength === 4 ? 
      (currentEntityPathLength !== previousEntityPathLength || isDifferentSubSectionFromPrevious ? true :
      hasSameEntityPathTransLevel && hasSameEntityPathIteratorLevel && hasSameEntityPathCategoryLevel && 
      !hasSameEntityPathSubCategoryLevel) : false;

    const belongsToSameIteratorPathLength4 = currentEntityPathLength === 4 && 
    hasSameEntityPathTransLevel && hasSameEntityPathIteratorLevel && hasSameEntityPathCategoryLevel;

    const isDifferentSectionFromPrevious = currentEntityPathLength === 3 && !hasSameEntityPathIteratorLevel;
    
    const shouldDisplaySubSection = currentEntityPathLength === 3 ? 
    (currentEntityPathLength !== previousEntityPathLength || isDifferentSectionFromPrevious ? true :
    hasSameEntityPathTransLevel && hasSameEntityPathIteratorLevel && !hasSameEntityPathCategoryLevel) :
    !belongsToSameIteratorPathLength4;

    const showSectionHeader = anIterator && 
      JSON.stringify(changeItem.entityPath[1]) !== JSON.stringify(changes?.[index-1]?.entityPath[1]);
    
    const showSubSectionHeader = anIterator && ((currentEntityPathLength === 3 || currentEntityPathLength === 4) ? 
      (index === 0) ? true : shouldDisplaySubSection : false);
    
    const showSubSubSectionHeader = anIterator && (currentEntityPathLength === 4 ? 
      (index === 0 ? true : shouldDisplaySubSubSection) : false);
    
    const topSectionStyle = showSectionHeader && index === 0 ? `${styles.topSection}` : '';
    const sectionStyle = showSectionHeader && styles.section;
    const iteratorFieldStyle = anIterator ? (currentEntityPathLength === 2 ? `${styles.nestedIteratorEntityPathLength2}` : 
      (currentEntityPathLength === 3 ? `${styles.nestedIteratorEntityPathLength3}` : `${styles.nestedIteratorEntityPathLength4}`)) : '';
    
    const entityAddedStyle = changeItem.to ? `${styles.changeTo}` : '';
    const entityRemovedStyle = changeItem.from ? styles.changeFrom : '';
    const entityAddedOrRemovedStyle = changeItem.to ? `${styles.changeTo}` : changeItem.from ? `${styles.changeFrom}` : '';
    
    return <>
      <div key={index} className={`${styles.changeLogItemWrapper} ${sectionStyle}`}>
        {showSectionHeader &&
          <div className={`${styles.sectionHeader} ${topSectionStyle}`}> 
            <span className={`${styles.sectionHeaderTitle}`}>
              {changeItem.entityPath[1]?.entityType}
            </span> 
            {changeItem.entityPath[1]?.description && renderHeaderDescription(changeItem.entityPath[1]?.description, 1)}
          </div>}
          {showSubSectionHeader && renderSubHeader(2)}
          {showSubSubSectionHeader && <span className={`${styles.subSubSectionHeaderWrapper}`}>{renderSubHeader(3)}</span>}
          {!changeItem.tagIncludedInEntityType && <div className={`${styles.details} ${iteratorFieldStyle}`}>
            {changeItem.fieldDescription && <span className={`${styles.fieldDescription}`}>
              <span>{changeItem.fieldDescription}</span>
            </span>}
            <span className={anIterator ? `${styles.iteratorFieldValue}` : styles.fieldValue}>
              <span className={entityAddedStyle}>{changeItem.to?.d || formattedValue(changeItem.to?.v)}</span>
              <span className={entityRemovedStyle}>{changeItem.from?.d || formattedValue(changeItem.from?.v)}</span>
            </span>
          </div>}
        </div>
    </>;
  };

  const changeLogItems = changes?.map((change, index) =><div key={index}>{renderChanges(change, index)}</div>);
  
  return <>
    <div>
      {!!changes && !changes?.length  ? <span className={styles.message}>{textMessageNoChangesExist}</span> : changeLogItems}
    </div>
  </>;
};
